import PropTypes from 'prop-types';
// material
import { styled } from '@mui/material/styles';
import { Toolbar, Tooltip, IconButton, Typography, OutlinedInput, InputAdornment, Card, MenuItem } from '@mui/material';
import { useState } from 'react';
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
  position: 'relative', // Position relative to contain absolute children
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

const DropdownCard = styled(Card)(({ theme }) => ({
  position: 'absolute',
  top: '100%', // Position below the toolbar
  left: '-100px', // Left align dropdown card
  zIndex: 10,
  padding: theme.spacing(2),
  minWidth: '150px',
}));

// ----------------------------------------------------------------------

HrconclaveListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  roleFilter: PropTypes.string,
  onRoleFilterChange: PropTypes.func,
};

export default function HrconclaveListToolbar({ numSelected, filterName, onFilterName, roleFilter, onRoleFilterChange }) {
  const [filterDropdownVisible, setFilterDropdownVisible] = useState(false); // State to manage dropdown visibility

  const handleToggleDropdown = () => {
    setFilterDropdownVisible((prev) => !prev); // Toggle dropdown visibility
  };

  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            placeholder="Search user..."
            startAdornment={
              <InputAdornment position="start">
                <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
              </InputAdornment>
            }
          />
          {/* Filter List Button */}
          <Tooltip title="Filter list">
            <IconButton onClick={handleToggleDropdown}>
              <Iconify icon="ic:round-filter-list" />
             
            </IconButton>
            
          </Tooltip>

       
        
        </>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <Iconify icon="eva:trash-2-fill" />
          </IconButton>
        </Tooltip>
      ) : null}
    </RootStyle>
  );
}